<template>
    <div class="Email">
        <div class="Emailform">
            <!-- <div class="item">
                <span><i class="el-icon-edit"></i>发件人：</span>
                <input class="input" />
            </div> -->
            <div class="item">
                <span><i class="el-icon-user"></i>收件人邮箱：</span>
                <input class="input" type="email" placeholder="请输入收件人邮箱" v-model="param.to"/>
            </div>
            <div class="item">
                <span><i class="el-icon-s-flag"></i>主题：</span>
                <input class="input" placeholder="请输入主题" v-model="param.title"/>
            </div>

            <div class="item" style="border:none;">
                <UEtext :defaultMsg=defaultMsg ref="ue"></UEtext>
            </div>

            <div class="sendbtn">
                <el-button type="primary" @click="send" :loading="loading">发送</el-button>
            </div>
        </div>
    </div>
</template>
<!-- this.Articlecontent=this.$refs.ue.getUEContent(); -->
<script>
import UEtext from '@/components/text.vue';
export default{
    components: { UEtext},
    data() {
        return {
            loading:false,
            defaultMsg: '',
            param:{
                to: "",//收件人
                title: "",//主题
                content: ""//内容
            }
        }
    },
    methods: {
         send(){
            var _this=this;
                if (!this.param.to) {
                this.$message({type: 'error', message:'收件人邮箱不能为空'});
                return false;
            }
            this.param.content=this.$refs.ue.getUEContent();
            this.loading=true;
            this.$Http_Post('/mail/sendhtml',this.param).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.loading=false;
                    this.param.title=''
                    this.param.content=''
                    setTimeout(function(){
                        _this.defaultMsg=''
                    },1000);
                    this.$message({type: 'success', message:"发送成功"});
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
         },
    },
}
</script>
<style scoped>
.Email{background: #fff;padding: 20px;height: 100%;}
.Email .Emailform{width: 800px;margin: auto;}
.Email .Emailform .item{padding: 8px;font-size: 16px;border-bottom:1px solid rgb(0 0 0 / 15%);}
.Email .Emailform .item i{margin-right:10px;}
.Email .Emailform .item .input{width: 80%;border:none;outline: none;font-size: 16px;padding-left: 10px;}
.Email .Emailform .sendbtn{margin:30px auto;text-align: center;display: block;}
</style>